/* tslint:disable */
/* eslint-disable */
/**
 * Knowspread API v1
 *  This document describes API of education system Knowspread. This API is used by AngularJS web application. ##Api path Api lives on path `./api/v1/{resource}` relative to the root of the deployed application. ##Api versioning This api is versioned to allow further updates that would break backward compatibility. Current version is `v1` and it will be finalized when the App is deployed into production. In every response with status code `2xx`, `400`, `401` or `403` is returned `X-API-Version` header with current api version. This value is for checking correct api version used in Android or iOS application. ## Request and Response format Both response and request bodies are of type `application/json` if not noted otherwise.  ## Authentication Client accessing Knowspread application authenticates itself with a `POST` request against endpoint `./api/v1/users/login` through invitation link or with username and password. If the user authentication is successful an user unique identificator `uid` is returned together with an `access-token`, `client` - type of client, which allows to be authenticated on more devices, and information about access token expiration. (Please see corresponding API spec for concrete JSON format of request and response)  Each API call of given client is then authenticated using the returned `access-token`,`client` and `uid` which is passed to the server in header. Server returns `401 - Unauthorized` if the given token is expired or not valid. In case of invalid token, client can request a new one by authenticating against `./api/v1/users/login` again. AccessToken validity is automatically prolonged by using it.  ## Error States  The common [HTTP Response Status Codes](https://github.com/for-GET/know-your-http-well/blob/master/status-codes.md) are used for signaling error states.  Error status codes are specified in first endpoint in API spec - `./api/v1/`.  ##Success code `200` status code is returned on success (it does not matter if it is a Create,Read,Delete or Update operation) ## Common patterns in KnowSpread API  All REST based resources in this follow these rules:  * CREATE (`POST`) - Returns status code `201 (OK)` when the creation of entity is successful. and contains dictionary representing the created entity, * READ (`GET`) - Returns status code `200 (OK)` and dictionary or array of dictionaries representing the entity requested. Dictionary with the same keys is expected by the server when updating the entity. * UPDATE (`PUT`) - Returns status code `200 (OK)` and dictionary that represents state of the entity after modification. * DELETE (`DELETE`) - Returns status code `204 (OK)` upon successful deletion of entity.  ## Date formatting API accepts and returns dates in ISO_8601. For more info see: http://en.wikipedia.org/wiki/ISO_8601 ## Documentation tags * PAGEABLE - this marks this request as pageable. If you want to iterate over pages, set query `\'page\' (integer)` to number requested page. You can set query `\'paginates_per\' (integer)`, what sets records count on one page. This request returns count of total pages, current page and total records count in header. * JOB PROCESSING always - where job scheduled always * JOB PROCESSING sometimes - where job scheduled sometimes * JOB PROCESSING callbacks - where shceduled any jobs to support main action of endpoint e.g. assign content to all users in group etc. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ApprovalRequestCreateCompetencesInner } from './ApprovalRequestCreateCompetencesInner';
import {
    ApprovalRequestCreateCompetencesInnerFromJSON,
    ApprovalRequestCreateCompetencesInnerFromJSONTyped,
    ApprovalRequestCreateCompetencesInnerToJSON,
} from './ApprovalRequestCreateCompetencesInner';

/**
 * 
 * @export
 * @interface ApprovalRequestCreate
 */
export interface ApprovalRequestCreate {
    /**
     * 
     * @type {string}
     * @memberof ApprovalRequestCreate
     */
    subject_title?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ApprovalRequestCreate
     */
    subject_date?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof ApprovalRequestCreate
     */
    subject_provider?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApprovalRequestCreate
     */
    subject_content?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ApprovalRequestCreate
     */
    subject_end_date?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof ApprovalRequestCreate
     */
    subject_start_time?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApprovalRequestCreate
     */
    subject_end_time?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApprovalRequestCreate
     */
    subject_location?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApprovalRequestCreate
     */
    reason?: string | null;
    /**
     * 
     * @type {Array<ApprovalRequestCreateCompetencesInner>}
     * @memberof ApprovalRequestCreate
     */
    competences?: Array<ApprovalRequestCreateCompetencesInner>;
    /**
     * 
     * @type {Array<number>}
     * @memberof ApprovalRequestCreate
     */
    competence_ids?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof ApprovalRequestCreate
     */
    study_time?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ApprovalRequestCreate
     */
    subject_expiration_date?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof ApprovalRequestCreate
     */
    price?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ApprovalRequestCreate
     */
    note?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApprovalRequestCreate
     */
    certificate_file_id?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ApprovalRequestCreate
     */
    attachment_file_ids?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ApprovalRequestCreate
     */
    request_type?: ApprovalRequestCreateRequestTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof ApprovalRequestCreate
     */
    user_id: number;
    /**
     * 
     * @type {string}
     * @memberof ApprovalRequestCreate
     */
    form?: ApprovalRequestCreateFormEnum;
    /**
     * 
     * @type {string}
     * @memberof ApprovalRequestCreate
     */
    budget?: string;
}


/**
 * @export
 */
export const ApprovalRequestCreateRequestTypeEnum = {
    RequestCourse: 'request_course',
    RequestTopic: 'request_topic',
    CourseCompletion: 'course_completion'
} as const;
export type ApprovalRequestCreateRequestTypeEnum = typeof ApprovalRequestCreateRequestTypeEnum[keyof typeof ApprovalRequestCreateRequestTypeEnum];

/**
 * @export
 */
export const ApprovalRequestCreateFormEnum = {
    Online: 'online',
    Combined: 'combined',
    InPerson: 'in_person',
    InPersonAndOnline: 'in_person_and_online'
} as const;
export type ApprovalRequestCreateFormEnum = typeof ApprovalRequestCreateFormEnum[keyof typeof ApprovalRequestCreateFormEnum];


/**
 * Check if a given object implements the ApprovalRequestCreate interface.
 */
export function instanceOfApprovalRequestCreate(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "user_id" in value;

    return isInstance;
}

export function ApprovalRequestCreateFromJSON(json: any): ApprovalRequestCreate {
    return ApprovalRequestCreateFromJSONTyped(json, false);
}

export function ApprovalRequestCreateFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApprovalRequestCreate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'subject_title': !exists(json, 'subject_title') ? undefined : json['subject_title'],
        'subject_date': !exists(json, 'subject_date') ? undefined : (json['subject_date'] === null ? null : new Date(json['subject_date'])),
        'subject_provider': !exists(json, 'subject_provider') ? undefined : json['subject_provider'],
        'subject_content': !exists(json, 'subject_content') ? undefined : json['subject_content'],
        'subject_end_date': !exists(json, 'subject_end_date') ? undefined : (json['subject_end_date'] === null ? null : new Date(json['subject_end_date'])),
        'subject_start_time': !exists(json, 'subject_start_time') ? undefined : json['subject_start_time'],
        'subject_end_time': !exists(json, 'subject_end_time') ? undefined : json['subject_end_time'],
        'subject_location': !exists(json, 'subject_location') ? undefined : json['subject_location'],
        'reason': !exists(json, 'reason') ? undefined : json['reason'],
        'competences': !exists(json, 'competences') ? undefined : ((json['competences'] as Array<any>).map(ApprovalRequestCreateCompetencesInnerFromJSON)),
        'competence_ids': !exists(json, 'competence_ids') ? undefined : json['competence_ids'],
        'study_time': !exists(json, 'study_time') ? undefined : json['study_time'],
        'subject_expiration_date': !exists(json, 'subject_expiration_date') ? undefined : (json['subject_expiration_date'] === null ? null : new Date(json['subject_expiration_date'])),
        'price': !exists(json, 'price') ? undefined : json['price'],
        'note': !exists(json, 'note') ? undefined : json['note'],
        'certificate_file_id': !exists(json, 'certificate_file_id') ? undefined : json['certificate_file_id'],
        'attachment_file_ids': !exists(json, 'attachment_file_ids') ? undefined : json['attachment_file_ids'],
        'request_type': !exists(json, 'request_type') ? undefined : json['request_type'],
        'user_id': json['user_id'],
        'form': !exists(json, 'form') ? undefined : json['form'],
        'budget': !exists(json, 'budget') ? undefined : json['budget'],
    };
}

export function ApprovalRequestCreateToJSON(value?: ApprovalRequestCreate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'subject_title': value.subject_title,
        'subject_date': value.subject_date === undefined ? undefined : (value.subject_date === null ? null : value.subject_date.toISOString().substr(0,10)),
        'subject_provider': value.subject_provider,
        'subject_content': value.subject_content,
        'subject_end_date': value.subject_end_date === undefined ? undefined : (value.subject_end_date === null ? null : value.subject_end_date.toISOString().substr(0,10)),
        'subject_start_time': value.subject_start_time,
        'subject_end_time': value.subject_end_time,
        'subject_location': value.subject_location,
        'reason': value.reason,
        'competences': value.competences === undefined ? undefined : ((value.competences as Array<any>).map(ApprovalRequestCreateCompetencesInnerToJSON)),
        'competence_ids': value.competence_ids,
        'study_time': value.study_time,
        'subject_expiration_date': value.subject_expiration_date === undefined ? undefined : (value.subject_expiration_date === null ? null : value.subject_expiration_date.toISOString().substr(0,10)),
        'price': value.price,
        'note': value.note,
        'certificate_file_id': value.certificate_file_id,
        'attachment_file_ids': value.attachment_file_ids,
        'request_type': value.request_type,
        'user_id': value.user_id,
        'form': value.form,
        'budget': value.budget,
    };
}

